import PropTypes from 'prop-types';

const SearchNormalSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.1654 35C27.9099 35 34.9987 27.9112 34.9987 19.1667C34.9987 10.4222 27.9099 3.33333 19.1654 3.33333C10.4209 3.33333 3.33203 10.4222 3.33203 19.1667C3.33203 27.9112 10.4209 35 19.1654 35Z"
        fill={color}
      />
      <path
        d="M35.5003 36.6667C35.2003 36.6667 34.9003 36.55 34.6836 36.3333L31.5836 33.2333C31.1336 32.7833 31.1336 32.05 31.5836 31.5833C32.0336 31.1333 32.7669 31.1333 33.2336 31.5833L36.3336 34.6833C36.7836 35.1333 36.7836 35.8667 36.3336 36.3333C36.1003 36.55 35.8003 36.6667 35.5003 36.6667Z"
        fill={color}
      />
    </svg>
  );
};

SearchNormalSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SearchNormalSvg;
